import PropTypes from '../_util/vue-types';

export default {
  name: 'ATableColumnGroup',
  props: {
    fixed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),
    title: PropTypes.any
  },
  __ANT_TABLE_COLUMN_GROUP: true
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/table/ColumnGroup.js
// module id = 744
// module chunks = 0